var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "91px",
    viewBox: "0 0 400.0 91.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480,0 L480,435 L0,435 L0,0 L480,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355,0 C379.852814,-4.56538782e-15 400,20.1471863 400,45 L400,46 C400,70.8528137 379.852814,91 355,91 L45,91 C20.1471863,91 -4.06183548e-15,70.8528137 0,46 L0,45 C-3.04359188e-15,20.1471863 20.1471863,4.56538782e-15 45,0 L355,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5,0 C38.0309764,0 49,10.9690236 49,24.5 C49,38.0309764 38.0309764,49 24.5,49 C10.9690236,49 0,38.0309764 0,24.5 C0,10.9690236 10.9690236,0 24.5,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.13220215,0 C9.67619629,0 10.6730469,1.01184082 10.6730469,2.56333008 L10.6730469,7.94482422 L9.36889648,7.94482422 L9.36889648,2.86313477 C9.36889648,1.79133301 8.77678223,1.15424805 7.74995117,1.15424805 C6.715625,1.15424805 5.98859863,1.92624512 5.98859863,2.99055176 L5.98859863,7.94482422 L4.68444824,7.94482422 L4.68444824,2.72072754 C4.68444824,1.77634277 4.0548584,1.15424805 3.08798828,1.15424805 C2.05366211,1.15424805 1.30415039,1.97121582 1.30415039,3.05800781 L1.30415039,7.94482422 L0,7.94482422 L0,0.149902344 L1.30415039,0.149902344 L1.30415039,1.28916016 L1.33413086,1.28916016 C1.68640137,0.517163086 2.46589355,0 3.47023926,0 C4.5345459,0 5.3215332,0.547143555 5.65881348,1.49902344 L5.68879395,1.49902344 C6.12351074,0.562133789 7.03791504,0 8.13220215,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.60515137,0 C5.75625,0 7.21779785,1.54399414 7.21779785,4.03237305 L7.21779785,4.04736328 C7.21779785,6.53574219 5.76374512,8.09472656 3.61264648,8.09472656 C1.44655762,8.09472656 0,6.52824707 0,4.04736328 L0,4.03237305 C0,1.55148926 1.45405273,0 3.60515137,0 Z M3.60515137,1.15424805 C2.24853516,1.15424805 1.33413086,2.21105957 1.33413086,4.03237305 L1.33413086,4.04736328 C1.33413086,5.88366699 2.24104004,6.94047852 3.6201416,6.94047852 C4.99174805,6.94047852 5.88366699,5.87617187 5.88366699,4.04736328 L5.88366699,4.03237305 C5.88366699,2.20356445 4.98425293,1.15424805 3.60515137,1.15424805 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.30415039,0 L1.30415039,4.32468262 L1.33413086,4.32468262 C1.82131348,3.42526855 2.72822266,2.87062988 3.83000488,2.87062988 C5.78623047,2.87062988 7.12036133,4.45209961 7.12036133,6.91049805 C7.12036133,9.3763916 5.8012207,10.9653564 3.80751953,10.9653564 C2.69074707,10.9653564 1.82131348,10.4032227 1.33413086,9.49631348 L1.30415039,9.49631348 L1.30415039,10.8154541 L0,10.8154541 L0,0 L1.30415039,0 Z M3.55268555,4.02487793 C2.24104004,4.02487793 1.29665527,5.17163086 1.29665527,6.91049805 C1.29665527,8.66435547 2.23354492,9.8111084 3.55268555,9.8111084 C4.93178711,9.8111084 5.78623047,8.70932617 5.78623047,6.91799316 C5.78623047,5.13415527 4.93178711,4.02487793 3.55268555,4.02487793 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.46904297,2.95307617 L1.46904297,10.747998 L0.164892578,10.747998 L0.164892578,2.95307617 L1.46904297,2.95307617 Z M0.816967773,0 C1.27416992,0 1.63393555,0.359765625 1.63393555,0.816967773 C1.63393555,1.2666748 1.27416992,1.63393555 0.816967773,1.63393555 C0.367260742,1.63393555 0,1.2666748 0,0.816967773 C0,0.359765625 0.367260742,0 0.816967773,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.30415039,0 L1.30415039,10.8154541 L0,10.8154541 L0,0 L1.30415039,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.50771484,0 C5.63632813,0 6.9329834,1.58146973 6.9329834,3.91994629 L6.9329834,4.39963379 L1.31914063,4.39963379 C1.34912109,6.00358887 2.23354492,6.94047852 3.6201416,6.94047852 C4.60949707,6.94047852 5.30654297,6.44580078 5.53139648,5.77873535 L5.55388184,5.7112793 L6.83554688,5.7112793 L6.82055664,5.78623047 C6.56572266,7.07539062 5.29155273,8.09472656 3.59016113,8.09472656 C1.34912109,8.09472656 0,6.52824707 0,4.07734375 C0,1.6564209 1.37910156,0 3.50771484,0 Z M3.50021973,1.15424805 C2.36845703,1.15424805 1.4840332,1.92624512 1.34162598,3.38029785 L5.60634766,3.38029785 C5.47893066,1.86628418 4.63947754,1.15424805 3.50021973,1.15424805 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.02148438,0 L9.26757812,10.4199219 L9.32617188,10.4199219 L9.32617188,0 L11.4941406,0 L11.4941406,14.0917969 L9.48242188,14.0917969 L2.2265625,3.65234375 L2.16796875,3.65234375 L2.16796875,14.0917969 L0,14.0917969 L0,0 L2.02148438,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49023438,0 L12.6074219,14.0917969 L10.3125,14.0917969 L9.0234375,10.2832031 L3.59375,10.2832031 L2.29492188,14.0917969 L0,14.0917969 L5.12695312,0 L7.49023438,0 Z M6.328125,2.33398438 L6.2890625,2.33398438 L4.1796875,8.52539062 L8.42773438,8.52539062 L6.328125,2.33398438 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.35351562,0 L6.20117188,11.6601562 L6.25,11.6601562 L10.0976562,0 L12.4511719,0 L7.43164062,14.0917969 L5.01953125,14.0917969 L0,0 L2.35351562,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7434922,0 C18.8408641,-0.0113379297 23.5153597,1.05156696 25.8811803,3.41738751 C26.9326561,4.45743423 27.5155394,5.74892081 27.4812522,7.31470543 C27.4469649,8.25189038 27.1498087,9.0633554 26.6012126,9.5890933 C26.1326202,10.0462567 25.5383077,10.3091256 24.8297045,10.1834057 L20.6238013,9.47480245 C19.9494853,9.36051161 19.503751,9.16621717 19.2065948,8.86906096 C18.829435,8.49190116 18.7151441,7.94330509 18.703715,7.20041458 L18.692286,6.02321884 C18.6808569,5.84035349 18.6122824,5.70320447 18.5094206,5.58891362 C18.3837007,5.46319369 18.2122644,5.39461918 18.0865445,5.36033193 C17.2979376,5.14317932 15.6864366,5.0060303 13.7434922,5.0060303 C11.7891187,5.0060303 10.1776178,5.17746657 9.38901092,5.36033193 C9.26329099,5.39461918 9.08042564,5.4517646 8.96613479,5.58891362 C8.85184394,5.70320447 8.77184035,5.85178257 8.77184035,6.03464793 L8.77184035,7.20041458 C8.77184035,7.94330509 8.6575495,8.49190116 8.26896061,8.86906096 C7.97180441,9.16621717 7.5260701,9.36051161 6.86318318,9.47480245 L2.61156364,10.1948348 C1.91438947,10.3091256 1.33150614,10.0576858 0.897200918,9.63480964 C0.348604848,9.07478449 0.0514486427,8.26331947 0.00573230351,7.3375636 C-0.0628422053,5.76034989 0.485753865,4.46886331 1.54865875,3.41738751 C3.90305022,1.05156696 8.63469133,0 13.7434922,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83785752,0 C4.48507018,0 5.0755098,0.249801377 5.4956303,0.828886388 L7.94822564,4.28068724 C8.33428231,4.83706303 8.52731065,5.29124735 8.52731065,5.70001324 C8.52731065,6.23367982 8.22073623,6.69921875 7.69842426,7.23288533 L6.89224709,8.06177172 C6.75599179,8.1866724 6.71057336,8.34563692 6.71057336,8.49324682 C6.71057336,8.66356594 6.77870101,8.83388506 6.84682865,8.95878575 C7.22153072,9.67412606 8.27750927,10.8890691 9.40161547,12.0245299 C10.5370763,13.1486361 11.7633739,14.2046147 12.4673596,14.5906713 C12.5922603,14.6474444 12.7625794,14.715572 12.9442532,14.715572 C13.0918631,14.715572 13.2508276,14.6701536 13.3757283,14.5452529 L14.2046147,13.7277211 C14.7269266,13.2054092 15.1924656,12.9101894 15.7261322,12.9101894 C16.134898,12.9101894 16.600437,13.0918631 17.1454582,13.4779198 L20.6313228,15.9532243 C21.2104078,16.3619902 21.4375,16.9410752 21.4375,17.5428694 C21.4375,18.3263374 21.0627979,19.1098053 20.4610037,19.7910818 C19.4163798,20.9492519 18.1105998,21.4602092 16.6231462,21.4602092 C13.3076006,21.4602092 9.24265095,18.8827132 5.89304158,15.5331038 C2.5434322,12.1834944 0,8.16396319 0,4.84841764 C0,3.37231859 0.499602754,2.05518406 1.62370895,0.9878509 C2.30498543,0.340638242 3.07709878,0 3.83785752,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40.0 -34.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.0 34.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 400,0 400,91 0,91 0,0",
    stroke: "none",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(269.5 21.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 49,0 49,49 0,49 0,0",
    stroke: "none",
    fill: "#E85544"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(331.5 21.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 49,0 49,49 0,49 0,0",
    stroke: "none",
    fill: "#68CD65"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.84694824218786 33.18454589843755)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 2.8706298828125227)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 10.6730469,0 10.6730469,7.94482422 0,7.94482422 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "50%"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.94721679687427 2.8706298828125227)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.21779785,0 7.21779785,8.09472656 0,8.09472656 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "50%"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.54411621093732 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.12036133,0 7.12036133,10.9653564 0,10.9653564 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "50%"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.8936767578125 0.06745605468756821)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.63393555,0 1.63393555,10.747998 0,10.747998 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "50%"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.20651855468714 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.30415039,0 1.30415039,10.8154541 0,10.8154541 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "50%"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.8897705078125 2.8706298828125227)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 6.9329834,0 6.9329834,8.09472656 0,8.09472656 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "50%"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.298828125 51.908203125)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 11.4941406,0 11.4941406,14.0917969 0,14.0917969 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.046875 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 12.6074219,0 12.6074219,14.0917969 0,14.0917969 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.53125 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i11)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 12.4511719,0 12.4511719,14.0917969 0,14.0917969 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.25 40.39999999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i12)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5.55111512e-15,-8.9714741e-05 27.482684,-8.9714741e-05 27.482684,10.2224133 5.55111512e-15,10.2224133 5.55111512e-15,-8.9714741e-05",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.24609375 34.79999999999995)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i13)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 21.4375,0 21.4375,21.4602092 0,21.4602092 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.48e9a2d0f7f0f05fecd8a03f57dd384e.svg";
export { ForwardRef as ReactComponent };